import _get from 'lodash/get';

export const DAI_YOSPACE = 'yospace';

export const isYospaceAsset = ({ provider }) => provider === DAI_YOSPACE;

export const getDAI = item => {
  const provider = _get(item, 'advertising.providers.dai');

  if (!provider) {
    return null;
  }

  return {
    provider,
    targeting: _get(item.advertising, `${provider}.targeting`) || {},
  };
};

export const arrangeSources = item => {
  const { provider, targeting } = getDAI(item) || {};

  return (_get(item, 'video.assets') || [])
    .filter(Boolean)
    .map(source => {
      if (provider !== DAI_YOSPACE) {
        return source;
      }

      if (source.provider === provider) {
        try {
          const url = new URL(source.path);

          if (url.searchParams.get('yo.eb.os') === 'fallback') {
            url.searchParams.delete('yo.eb.os');
          }

          Object.entries(targeting).forEach(([key, value]) => {
            url.searchParams.append(key, value);
          });

          const path = url.toString();

          return {
            ...source,
            path,
            reference: path,
          };
        } catch (error) {
          return source;
        }
      }

      return source;
    })
    .sort((a, b) => {
      if (isYospaceAsset(a)) {
        return -1;
      }

      if (isYospaceAsset(b)) {
        return 1;
      }

      return 0;
    });
};
